import React from 'react'
import { Bar } from "react-chartjs-2";

import ChartDataLabels from 'chartjs-plugin-datalabels';
import Chart from 'chart.js';

const VerticalBarChart = (props) => {
    return (
        <>
            {props?.data &&
                <Bar data={props?.data} options={props?.options}></Bar>
            }
        </>
    )
};

export default VerticalBarChart